/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { findPermission, Permission } from '@gh/core-auth';

import * as invariant from 'invariant';
import { isString } from 'lodash';

import { UserContext } from '../user';

@Directive({
  selector: '[ghAllowFor]',
})
export class AllowForDirective {
  private hasView = false;

  constructor(private viewContainerRef: ViewContainerRef,
              private templateRef: TemplateRef<Object>,
              private userContext: UserContext) {
  }

  @Input()
  set ghAllowFor(permission: any) {
    if (isString(permission)) {
      permission = findPermission(permission);
    }

    invariant(permission instanceof Permission, `Permission '${permission}' is not an instance of Permission`);

    if (this.userContext.hasPermission(permission) && !this.hasView) {
      this.hasView = true;
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else if (!this.userContext.hasPermission(permission) && this.hasView) {
      this.hasView = false;
      this.viewContainerRef.clear();
    }
  }
}
